import React, {ReactElement} from 'react';
import {cx} from '@emotion/css';
import {LinkProp} from '../../../types';
import LayoutSection from '../Layout/LayoutSection/LayoutSection';
import PageTitle from '../PageTitle/PageTitle';

import styles from './LinkColumnsWithTitle.styles';
import DynamicLink from '../../DynamicLink/DynamicLink';
import {LayoutBackground} from '../Layout/LayoutSection/LayoutSection.types';

interface LinkColumnsWithTitleProps {
  className?: string;
  links: LinkProp[];
  title: string;
}

function LinkColumnsWithTitle({className, links, title}: LinkColumnsWithTitleProps): ReactElement | null {
  if (!links.length) {
    return null;
  }

  return (
    <LayoutSection className={cx(className)} type={LayoutBackground.GRAY}>
      <div className={cx(styles.titleWrap)}>
        <PageTitle text={title} className={cx(styles.title)} />
      </div>
      <div className={cx(styles.linksWrap)}>
        {links.map((link) => (
          <DynamicLink className={cx(styles.link, 'unstyledLink')} key={link.label} href={link.href}>
            {link.label}
          </DynamicLink>
        ))}
      </div>
    </LayoutSection>
  );
}

export default LinkColumnsWithTitle;
